let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("QBdFT")).then(() => parcelRequire('2vAnn'));